import axios from "axios";
import { useState, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Webcam from "react-webcam";
import { url } from "../link";
import Navbar from "../components/Navbar";

const videoConstraints = {
  width: { ideal: 1280 },
  height: { ideal: 720 },
  facingMode: "environment", // Use "user" for front camera and "environment" for rear camera
};

const Addlaptop2025 = () => {
  const { state } = useLocation();

  const [laptopname, setlaptopname] = useState("");
  const [addons, setaddons] = useState("");
  const [givendate, setgivendate] = useState("");
  const [deliverydate, setdeliverydate] = useState("");
  const [commiment, setcommiment] = useState("");
  const [pid, setpid] = useState(state);
  const [receivedby, setreceivedby] = useState(-1);
  const [screenshot, setScreenshot] = useState(null);

  const webcamRef = useRef(null);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setScreenshot(imageSrc);
  };

  const submitdata = () => {
    const value = {
      laptopname,
      addons,
      givendate,
      deliverydate,
      commiment,
      pid,
      receivedby,
      photo: screenshot,
    };
    axios.post(url + "/edusphere/insertlaptop2025", value).then(() => {
      alert("success");
      setlaptopname("");
      setaddons("");
      setgivendate("");
      setdeliverydate("");
      setcommiment("");
      setScreenshot(null);
    });
  };

  return (
    <>
      <Navbar />
      <div className="container mt-5">
        <NavLink to="/viewlaptop2025" className="btn btn-secondary mb-3">
          Back to Laptop List
        </NavLink>
        <div className="card shadow-lg border-0 rounded-3">
          <div className="card-header bg-primary text-white text-center">
            <h3 className="mb-0">Add Laptop Details</h3>
          </div>
          <div className="card-body p-4">
            <form>
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setlaptopname(e.target.value)}
                  value={laptopname}
                  placeholder="Enter laptopname"
                />
                <label htmlFor="laptopname">Laptop Name</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setaddons(e.target.value)}
                  value={addons}
                  placeholder="Enter addons"
                />
                <label htmlFor="addons">Add-ons</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setgivendate(e.target.value)}
                  value={givendate}
                />
                <label htmlFor="givendate">Given Date</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="datetime-local"
                  className="form-control"
                  onChange={(e) => setdeliverydate(e.target.value)}
                  value={deliverydate}
                />
                <label htmlFor="deliverydate">Delivery Date & Time</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setcommiment(e.target.value)}
                  value={commiment}
                  placeholder="Enter commitment"
                />
                <label htmlFor="commiment">Commitment</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setpid(e.target.value)}
                  value={pid}
                  placeholder="Enter pid"
                />
                <label htmlFor="pid">PID</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setreceivedby(e.target.value)}
                  value={receivedby}
                  placeholder="Enter received by"
                />
                <label htmlFor="receivedby">Received By</label>
              </div>

              <div className="mb-4 text-center">
                <h5 className="mb-3">Capture Laptop Photo</h5>
                <div className="d-flex justify-content-center">
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    videoConstraints={videoConstraints}
                    className="rounded shadow-sm"
                    style={{ width: "60%", border: "2px solid #ccc" }}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-outline-primary mt-3"
                  onClick={capture}
                >
                  Capture Photo
                </button>

                {screenshot && (
                  <div className="mt-3">
                    <img
                      src={screenshot}
                      alt="Captured"
                      className="img-thumbnail"
                      style={{ maxWidth: "300px" }}
                    />
                  </div>
                )}
              </div>

              <button
                type="button"
                className="btn btn-success w-100 py-2"
                onClick={submitdata}
              >
                Submit Laptop Details
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Addlaptop2025;
